import { useState } from "react";
import { ArrowRight } from "lucide-react";

const BeforeAfterSlider = ({ project, index }) => {
  const [value, setValue] = useState(58);
  const beforeSrc = project.before || project.after;
  return (
    <article className={`ba-card ba-${index + 1}`} data-testid={`before-after-card-${index + 1}`}>
      <div className="ba-media">
        <img className="ba-after" src={project.after} alt={`${project.title} sonra`} />
        <div className="ba-before" style={{ width: `${value}%` }}>
          <img className={`ba-before-img ${project.before ? "" : "is-simulated"}`} src={beforeSrc} alt={`${project.title} önce`} />
        </div>
        <div className="ba-divider" style={{ left: `${value}%` }}><span /></div>
        <span className="ba-chip ba-chip-before">Önce</span><span className="ba-chip ba-chip-after">Sonra</span>
      </div>
      <input className="ba-range" type="range" min="8" max="92" value={value} onChange={(event) => setValue(Number(event.target.value))} aria-label={`${project.title} önce sonra karşılaştırma`} data-testid={`before-after-range-${index + 1}`} />
      <div className="ba-meta"><div><span>{project.tag}</span><h3>{project.title}</h3></div><a href="/#quote" data-testid={`before-after-cta-${index + 1}`}><ArrowRight size={18} /></a></div>
    </article>
  );
};

export default BeforeAfterSlider;
